module.exports = __webpack_public_path__ + "img/partnership_07.922f91a6.jpg";